import { LitElement, html, css, classMap, unsafeHTML } from './-global.min.js'

class HHWishlistButton extends LitElement {
  static properties = {
    _active: {
      state: false,
    },
  }

  constructor() {
    super()
  }

  onClick(e) {
    e.preventDefault()

    this._active = !this._active
  }

  render() {
    return html` <div
      class="${classMap({ 'is-active': this._active })}"
      @click="${this.onClick}"
    >
      <slot></slot>
    </div>`
  }

  static styles = css`
    :host {
      width: 25px;
      height: 25px;
      display: block;
      position: absolute;
      top: 1em;
      right: 1em;
      z-index: 2;
    }
    :host(:hover) {
      cursor: pointer;
    }
    ::slotted(svg) {
      transition: fill var(--hh-transition, 400ms) ease;
      fill: white;
    }
    .is-active ::slotted(svg) {
      fill: red;
    }
  `
}

customElements.define('hh-wishlist-button', HHWishlistButton)
